import { render, staticRenderFns } from "./rebate-detail.vue?vue&type=template&id=4707f8c3&"
import script from "./rebate-detail.vue?vue&type=script&lang=js&"
export * from "./rebate-detail.vue?vue&type=script&lang=js&"
import style0 from "./rebate-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports